import { render, staticRenderFns } from "./PacienteV2.vue?vue&type=template&id=11ed5b57&scoped=true"
import script from "./PacienteV2.vue?vue&type=script&lang=js"
export * from "./PacienteV2.vue?vue&type=script&lang=js"
import style0 from "./PacienteV2.vue?vue&type=style&index=0&id=11ed5b57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed5b57",
  null
  
)

export default component.exports